import { useMemo } from 'react';
import { Box, Center, FloatingContainer, Screen, Text } from '~/commonComponents';
import { routes } from '~/routes';
import { Colors } from '~/themes/colors';
import { NumberUtils } from '~/utils/NumberUtils';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';
import { TOfficeTutorial, useOfficeTutorial } from '../OfficeTutorialPopup';
import { HelpMenuLink } from './HelpMenuLink';
import { HelpSection } from './HelpSection';

export const HelpScreen = () => {
  const controls = useOfficeTutorial();
  const tutorials = RemoteConfigUtils.getOfficeTutorials() as TOfficeTutorial[];
  const csPhoneNumber = useMemo(() => NumberUtils.getCSPhone(), []);

  return (
    <Screen>
      <FloatingContainer borderRadius={0} flex={1} margin={12} minWidth="auto">
        <Box position="relative" marginBottom={32} marginTop={48}>
          <Center>
            <Text fontSize={32} bold textAlign="center">
              Help Center
            </Text>
          </Center>
        </Box>
        <Box
          backgroundColor={Colors.neutral_50}
          flex={1}
          marginHorizontal={56}
          paddingBottom={80}
          paddingHorizontal={40}
          paddingTop={40}
          width="auto"
          gap={12}
          marginBottom={60}
        >
          <HelpSection title="About GoTu">
            <HelpMenuLink href={routes.about} text="About" />
            <HelpMenuLink href={routes.howItWorks} text="How it Works" />
          </HelpSection>

          <HelpSection title="GoTu Tutorials">
            {tutorials
              .sort((a, b) => a.position - b.position)
              .map((tutorial) => (
                <HelpMenuLink
                  key={tutorial.id}
                  text={tutorial.title}
                  onClick={() => controls.setTutorial(tutorial)}
                />
              ))}
          </HelpSection>

          <HelpSection title="Contact Us">
            <Text fontSize={18}>
              Customer Service Text/Call:
              <Text bold fontSize={18}>{` ${csPhoneNumber.formatted}`}</Text>
            </Text>
          </HelpSection>
        </Box>
      </FloatingContainer>
    </Screen>
  );
};
